export const getSectionName = (breadcrumbData) => {
  return breadcrumbData[breadcrumbData.length - 1].sectionName ?? null;
};
